import { useEffect, useRef, useState } from "react";
import {
  calculateNetAndVat,
  getOtherValues,
  parseFormattedNumber,
} from "./utils";
import formatMoney from "../../../../../formatMoney";
import ToastSuccess from "../../../../../components/ToastSuccess";
import Form from "./Form";

function FormDialog({
  object,
  onCancel,
  setState,
  receipts,
  onSubmit,
  ...props
}) {
  const [formData, setFormData] = useState(() => {
    return object
      ? {
          id: object.id || "",
          date: object.date || "",
          client: object.client || "",
          gross: parseFormattedNumber(object.gross) || "",
          net: object.net || "",
          vat: object.vat || "",
          vatExempt: object.vatExempt || "",
          zeroRated: object.zeroRated || "",
          status: object.status || "pending",
          image: object?.image || "",
          bank: object?.bank || "",
          isVatable: object?.isVatable || false,
        }
      : {
          date: "",
          client: "",
          gross: "",
          net: "",
          vat: "",
          vatExempt: "",
          zeroRated: "",
          status: "pending",
          image: "",
          bank: "",
          isVatable: false,
        };
  });

  const [tinNo, setTinNo] = useState(object?.client?.tinNo || "");
  const [isShowToast, setshowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const pointerInput = useRef();

  useEffect(() => {
    if (object) {
      setFormData({
        id: object.id,
        date: object.date || "",
        client: object.client || "",
        gross: parseFormattedNumber(object.gross) || "",
        net: object.net || "",
        vat: object.vat || "",
        vatExempt: object.vatExempt || "",
        zeroRated: object.zeroRated || "",
        status: object.status || "pending",
        image: object.image || "",
        bank: object.bank || "",
        isVatable: object.isVatable || false,
      });
      setTinNo(object?.client?.tinNo || "");
    } else {
      resetFormData();
    }
  }, [object]);

  useEffect(() => {
    const otherValues = calculateNetAndVat(
      formData,
      formData?.isVatable || false,
    );
    setFormData((prev) => ({
      ...prev,
      net: otherValues.net,
      vat: otherValues.vat,
    }));
  }, [
    formData.gross,
    formData.vatExempt,
    formData.zeroRated,
    formData.supplier,
    formData.isVatable,
  ]);

  const onChange = (value, field) => {
    if (field === "client") {
      setFormData((prev) => ({ ...prev, client: value }));
      setTinNo(value?.tinNo || "N/A");
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedObject = {
      ...formData,
      gross: formatMoney(formData.gross),
      net: formData?.isVatable ? formData?.net : 0,
      vat: formData?.isVatable ? formData?.vat : 0,
      vatExempt: formData?.isVatable ? formData?.vatExempt : 0,
    };
    onSubmit(updatedObject, object);
  };

  const resetFormData = () => {
    setFormData({
      id: crypto.randomUUID(),
      date: "",
      gross: "",
      net: "",
      vat: "",
      vatExempt: "",
      zeroRated: "",
      image: "",
      bank: "",
      status: "pending",
      isVatable: false,
    });
    setTinNo("");
    pointerInput.current.onClickClear();
  };

  function showToast(message, timeout = 1500) {
    setToastMessage(message);
    setshowToast(true);
    setTimeout(() => setshowToast(false), timeout);
  }

  return (
    <>
      <div className="m-0 card bg-white p-3 position-relative">
        <div className="d-flex flex-column">
          <div style={{ borderBottom: "1px solid gray" }}>
            <p className="mb-1" style={{ fontSize: "0.9rem" }}>
              Transaction Details
            </p>
          </div>
          <Form
            onChange={onChange}
            formData={formData}
            setFormData={setFormData}
            tinNo={tinNo}
            handleSubmit={handleSubmit}
            resetRef={pointerInput}
            {...props}
          />
        </div>

        <div
          className="toast-container position-fixed"
          style={{ transform: "translate(-50%,-50%)", top: "10%", left: "50%" }}
        >
          <ToastSuccess show={isShowToast} message={toastMessage} />
        </div>
      </div>
    </>
  );
}

export default FormDialog;
